import { z } from 'zod';
import { Email, IsoDateTime, PageQuery, Slug, Uuid } from './common.js';
export const TenantStatus = z.enum(['active', 'suspended', 'archived']);
export const TenantSummary = z.object({
    id: Uuid,
    name: z.string(),
    slug: Slug,
    status: TenantStatus,
    partnerId: Uuid.nullable(),
    userCount: z.number().int().min(0),
    enabledModules: z.array(z.string()),
    createdAt: IsoDateTime,
    updatedAt: IsoDateTime,
});
export const TenantListQuery = PageQuery.extend({
    status: TenantStatus.optional(),
    sort: z.enum(['name', 'createdAt', 'status']).optional(),
});
/** Creates the tenant, its built-in roles and default settings, and invites the first administrator. */
export const TenantCreate = z.object({
    name: z.string().trim().min(1).max(120),
    slug: Slug,
    adminEmail: Email,
    adminFullName: z.string().trim().min(1).max(120),
    modules: z.array(z.string()).default([]),
});
export const TenantUpdate = z
    .object({
    name: z.string().trim().min(1).max(120),
    slug: Slug,
    status: TenantStatus,
})
    .partial();
export const TenantModuleToggle = z.object({ enabled: z.boolean() });
export const ModuleRegistryEntry = z.object({
    key: z.string(),
    version: z.string(),
    dependsOn: z.array(z.string()),
    /** False for 'core' (always on). */
    hasFeatureFlag: z.boolean(),
    nameKey: z.string(),
});
/** Usage metric names. Add new ones here; counters are per tenant per calendar month (UTC). */
export const UsageMetric = z.enum([
    'visits',
    'sms_sent',
    'emails_sent',
    'storage_bytes',
    'active_users',
    'kiosk_devices',
    // Phase 4 (spec 8.6.1, docs/modules/core-phase4.md s5): billing charges extras from these.
    'sites',
    'ai_questions',
    // Shared reception (ADR 0034): company links on shared kiosks, counted, not in kiosk_devices. Free for now (Perry, 26 Oct 2026).
    'shared_kiosk_links',
]);
export const UsageRow = z.object({
    metric: UsageMetric,
    /** First day of the month, YYYY-MM-01. */
    period: z.string().regex(/^\d{4}-\d{2}-01$/),
    value: z.number(),
});
export const TenantUsageResponse = z.object({
    tenantId: Uuid,
    rows: z.array(UsageRow),
});
export const PlatformAdmin = z.object({
    accountId: Uuid,
    email: z.string(),
    fullName: z.string(),
    createdAt: IsoDateTime,
});
export const PlatformAdminCreate = z.object({
    email: Email,
    fullName: z.string().trim().min(1).max(120),
});
//# sourceMappingURL=platform.js.map